var e = {};
export {
  e as __exports
};
//# sourceMappingURL=index.es487.js.map
